import { buildApiUrl, Type, sendPutRequest } from "../api";
import {type UpdateAssetSettings } from "./schemas";

export async function saveAssetSettings(assetCode: number, settings: UpdateAssetSettings) {

    const url = buildApiUrl(Type.AssetManagement, `asset/${assetCode}/settings`);
    await sendPutRequest(url, { data: settings });
}
